import React from 'react';
import AltNavbar from '../../components/altNavbar/AltNavbar';
import Hero from '../../containers/hero/Hero';
import ListCard from '../../components/listCard/ListCard';
import GalleryContainer from '../../containers/galleryContainer/GalleryContainer';
import Downloads from '../../containers/downloads/Downloads';

import header2019 from '../../assets//2019/2019header.webp';
import img2019 from './images19';
import highlight19 from '../../assets/2019/19highlights.pdf';
import report19 from '../../assets/2019/19-20report.pdf';

const listItems = [
  {
    heading: '推廣「一帶一路」發展倡議，加深香港各界青年對祖國的認識',
    text: '希望香港各界青年透過親身考察「一帶一路」沿線城市，了解祖國經濟發展的情況，以及「一帶一路」發展倡議的推動。項目會就「一帶一路」主題制定一些全方位的學習考察計劃，包括出發前的研討會、邀請國內教授講課等，以加深香港各界青年對政策的熟悉。',
    image: img2019.img1,
  },
  {
    heading: '支援基層青年發展，走出香港擴闊視野	',
    text: '新來港、少數族裔及基層青少年礙於經濟困難，鮮有機會到內地交流，對個人發展造成局限。他們能夠藉此計劃到內地進行交流學習，了解中國最新發展，協助他們擴闊視野。',
    image: img2019.img2,
  },
  {
    heading: '鼓勵青年人創業，投身於兩地經濟文化建設',
    text: '「一帶一路」發展倡議將會為內地、香港帶來許多的商業機會，交流團透過親身考察「一帶一路」沿線城市，鼓勵青年人把握「一帶一路」發展倡議所帶來的機遇，積極投身於兩地經濟文化建設。',
    image: img2019.img3,
  },
];

const images2019 = [
  { img: img2019.img1 },
  { img: img2019.img2 },
  { img: img2019.img3 },
  { img: img2019.img4 },
  { img: img2019.img5 },
  { img: img2019.img6 },
  { img: img2019.img7 },
  { img: img2019.img8 },
  { img: img2019.img9 },
  { img: img2019.img10 },
  { img: img2019.img11 },
  { img: img2019.img12 },
  { img: img2019.img13 },
  { img: img2019.img14 },
  { img: img2019.img15 },
  { img: img2019.img16 },
  { img: img2019.img17 },
  { img: img2019.img18 },
  { img: img2019.img19 },
  { img: img2019.img20 },
  { img: img2019.img21 },
  { img: img2019.img22 },
  { img: img2019.img23 },
  { img: img2019.img24 },
  { img: img2019.img25 },
  { img: img2019.img26 },
  { img: img2019.img27 },
  { img: img2019.img28 },
];

const Event19 = () => {
  return (
    <div>
      <AltNavbar />
      <Hero image={header2019} />
      {listItems.map((listItem, i) => (
        <ListCard
          key={'list-' + i}
          image={listItem.image}
          heading={listItem.heading}
          text={listItem.text}
        />
      ))}
      <GalleryContainer images={images2019} />
      <Downloads
        hasReport={true}
        reportLink={report19}
        highlightLink={highlight19}
      />
    </div>
  );
};

export default Event19;
